export function useConstructionSite() {
  const currentConstructionSite = useState<null | string>('currentSite', () => null);

  return { currentConstructionSite };
}
